import(/* webpackMode: "eager", webpackExports: ["HeroV3Tabbed"] */ "/vercel/path0/src/components/landing-v2/hero/hero-v3-tabbed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingShell"] */ "/vercel/path0/src/components/landing-v2/landing-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterV2"] */ "/vercel/path0/src/components/landing-v2/shared/footer-v2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavV2"] */ "/vercel/path0/src/components/landing-v2/shared/nav-v2.tsx");
